import {getItem, removeItem, setItem} from '@/utils/storage'
import router from '@/router/index';
// import axios from 'axios'
import {apiLogin, apiLoginOut, apiQueryUser, apiUpdatePwd, apiUpdateUser} from '@/api/user.js'
import {clearMenuRouter, createMenuRouter} from "../../router";

export default {
    // 开启命名空间
  namespaced: true,
  state: () => ({
    userInfo: getItem('userInfo') || {},
    menus: getItem('menus') || []
  }),
  mutations:{
    setUserInfo(state,userInfo){
        state.userInfo = userInfo
        setItem('userInfo', userInfo)
    },
    removeUserInfo(state){
      state.userInfo = {}
      removeItem('userInfo')
    },
    setMenus(state,menus){
      state.menus = menus
      setItem('menus', menus)
    },
    removeMenus(state){
      state.menus = []
      removeItem('menus')
    }
  },
  actions:{
    async login(context,data) {
       //登录成功 存储用户信息 菜单 token
      // apiLogin({username:data.username,password:data.password,nvcVal:data.nvcVal}).then((res)=>{
          // 新增路由
          createMenuRouter(data.menus)
          this.commit('user/setUserInfo',data.userInfo);
          this.commit('user/setMenus',data.menus);
          router.push('/home');
      // })
    },
    async loginOut(context){
      apiLoginOut({}).then((res)=>{
        clearMenuRouter()
        this.commit('user/removeMenus');
        this.commit('user/removeUserInfo');
        router.push('/login');
      })
    },
    async updateUser(context,data){
      apiUpdateUser(data).then((res)=>{
        apiQueryUser({username:data.userName}).then((resUser)=>{
          const userInfo = resUser
          //userInfo.menuKeys = res.menus
          userInfo.menus = this.getters.userInfo.menus
          this.commit('user/setUserInfo',userInfo);
        })
      })
    },
    async updatePwd(context,data) {
      apiUpdatePwd(data).then((res) => {
        //console.log(res,'res')
        const vm=this._vm
        this.commit('user/removeUserInfo')
        vm.$message.success('修改密码成功，既将跳转登录页');
        setTimeout(function () {
          router.push('/login');
        }, 1000);
      })
    },
  }
}





// WEBPACK FOOTER //
// ./src/store/modules/user.js